import * as React from 'react';
import useStyles from './style';

function NotFound() {
  const classes = useStyles();

  return (
    <div className={classes.notFoundContainer}>
            Page is not found
    </div>
  );
}

export default NotFound;
